import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ActionCardUI from './ActionCardUI';
import { routingActionCreator } from './actions/routingActionCreators';

const mapStateToProps = (state) => {
    return {
        offer: state.offer,
        creditApp: state.creditApp,
        init: state.init
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onCardClick: (route) => dispatch(routingActionCreator(route))
    };
};

const ActionCardContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ActionCardUI);

export default ActionCardContainer;
